import { Box, CollapsibleCard, Stack } from '@atgfr8/atg-ui-tailwind';
import { Button, Input } from '@components';
import { downloadCustomerAugmentContactCard } from '@store/customers/customerDetails';
import { customerLTLSettings } from '@store/customers/customerDetails/LTL';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { isAdmin } from '@utils/utils';
import { createSignal, Show } from 'solid-js';

const ExternalSetup = (props: { customerId: number | null | undefined }) => {
  const [displayName, setDisplayName] = createSignal('');
  const [isDownloading, setIsDownloading] = createSignal(false);

  const onDisplayNameInput = (e: { target: { value: string } }) => {
    setDisplayName(e.target.value);
  };

  const onDownloadContactCard = async () => {
    if (!props.customerId) {
      return;
    }

    setIsDownloading(true);
    await downloadCustomerAugmentContactCard(props.customerId, displayName());
    setIsDownloading(false);
  };

  return (
    <Show when={isAdmin()}>
      <CollapsibleCard
        startTitle="External Setup"
        loading={customerLTLSettings.isLoading}
        class="mb-2"
      >
        <Stack spacing={2} class="p-3">
          <Box class="text-[#000000] text-[12px] font-medium">
            Download a contact card agents can save to their email client to
            submit LTL quote requests on the customer's behalf.
          </Box>
          <Input
            label="Contact Display Name (optional)"
            value={displayName()}
            onInput={onDisplayNameInput}
          />
          <Box>
            <Button
              size="sm"
              variant="outlined"
              label="Download Augment Contact Card"
              isLoading={isDownloading()}
              disabled={isDownloading() || !props.customerId}
              onClick={onDownloadContactCard}
              dataTestId={formatDataTestId(
                'Download Augment Contact Card',
                'button',
              )}
            />
          </Box>
        </Stack>
      </CollapsibleCard>
    </Show>
  );
};

export default ExternalSetup;
